import { apiCall } from "../../../../utils/apiCall";
import { header } from "../../utils/zippyAdminHeader";
import { MethodType } from "../content/channelTypes";

export const fetchChannelTabs = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/channels/admin/tabs`
  });
};

export const fetchChannelVideosById = async (channelId: number) => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/channels/admin/${channelId}/videos`,
  });
};

export const updateChannelVideosSort = async (channelId: number, payload: any) => {
  return apiCall({
    method: "PATCH",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/channels/admin/${channelId}/videos/sort`,
    payload: payload
  });
};

export const channelVideoMutation = async (method: MethodType, payload: any) => {
  return apiCall({
    method: method,
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/channels/admin/video`,
    payload: payload
  });
};

export const channelVideoDelete = async (videoId: number) => {
  return apiCall({
    method: "DELETE",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/channels/admin/video/${videoId}`,
  });
};
